module.exports = __webpack_public_path__ + "static/woman-drinking-coffee-and-looking-out-the-window.4fd7e3c6.webp";